import { axios } from './Mixins/axios';

function loadCsrfToken() {
    return axios.get('/csrf-token').then((response) => {
        const token = response.data;

        // Assign all form inputs to the new csrf token
        document.querySelectorAll('form input[name="_token"]').forEach(function(item) {
            item.value = token;
        });

        // Assign to the meta title tag
        document.querySelectorAll('meta[name="csrf-token"]').forEach(function(item) {
            item.content = token;
        });
    });
}

window.addEventListener('load', () => {
    loadCsrfToken().then(() => {
        setInterval(loadCsrfToken, 15 * 60 * 1000);
    });
});
